module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "figcenter1",
    attrs: {
      "id": "Fig_Frontispiece"
    }
  }, [_c('img', {
    staticClass: "calibre13",
    attrs: {
      "alt": "",
      "id": "id-695928782557135104",
      "src": "Images/img0001.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption",
    attrs: {
      "id": "ebm_caption0"
    }
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Evil in such a Shape might be something more than Good.")]), _vm._v("\n("), _c('em', {
    staticClass: "calibre14"
  }, [_vm._v("Frontispiece.")]), _vm._v(")")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-156ff48b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0